import React, { useState } from "react";
import {
  IconButton,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Popover,
} from "@mui/material";
import { FilterListRounded } from "@mui/icons-material";
import { filterStyles } from "../../context/customStyles";

const FilterMenu = ({
  categories,
  decks,
  filter,
  setFilter,
  handleCategoryChange,
  handleDeckChange,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isOpen = Boolean(anchorEl);

  return (
    <>
      <IconButton
        style={filterStyles}
        disabled={categories?.length === 0 && decks?.length === 0}
        onClick={handleOpen}
      >
        <FilterListRounded color="black" />
      </IconButton>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              square: false,
              zIndex: 10000000,
              boxShadow: "var(--box-shadow)",
              borderRadius: "8px",
              marginTop: "1rem",
            },
            className: "popover-menu",
            onMouseLeave: () => {
              setTimeout(() => handleClose(), 800);
            },
          },
        }}
      >
        <div className="filter-menu">
          <div
            className="header gap-4"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 8,
            }}
          >
            <h6 className="mb-0">Filter Cards</h6>
          </div>

          <div className="filter-options">
            {categories?.length > 0 && (
              <div className="filter-group">
                <FormLabel className="filter-subtitle">By Category</FormLabel>
                <RadioGroup
                  className="filter-content"
                  name="category-filter"
                  value={filter.category}
                  onChange={handleCategoryChange}
                >
                  {categories.map((category) => (
                    <FormControlLabel
                      className="m-0 filter-radio"
                      key={category.id}
                      label={category.name}
                      value={category.name}
                      control={
                        <Radio
                          color="black"
                          size="small"
                          onClick={(e) => {
                            if (filter.category === category.name) {
                              setFilter({
                                ...filter,
                                category: "",
                              });
                            }
                          }}
                        />
                      }
                    />
                  ))}
                </RadioGroup>
              </div>
            )}

            {decks?.length > 0 && (
              <>
                <div className="filter-group">
                  <FormLabel className="filter-subtitle">By Deck</FormLabel>
                  <FormGroup
                    className="filter-content"
                    onChange={handleDeckChange}
                  >
                    {decks.map((deck) => {
                      return (
                        <FormControlLabel
                          className="m-0"
                          key={deck.id}
                          label={deck.name}
                          control={
                            <Checkbox
                              color="black"
                              size="small"
                              checked={filter.deck
                                .split(",")
                                .includes(deck.name)}
                              value={deck.name}
                            />
                          }
                        />
                      );
                    })}
                  </FormGroup>
                </div>

                <div className="filter-group">
                  <FormLabel className="filter-subtitle">
                    In Study Pile
                  </FormLabel>
                  <FormGroup className="filter-content">
                    <FormControlLabel
                      className="m-0"
                      label="Need Studying"
                      control={
                        <Checkbox
                          color="black"
                          size="small"
                          checked={!!filter.study}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              study: e.target.checked,
                            })
                          }
                        />
                      }
                    />
                  </FormGroup>
                </div>
              </>
            )}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default FilterMenu;
